<template>
  <div class="countdown-display"
    :class="{
      'countdown-display--hidden': !counterReady
    }">
    <span class="countdown-display__label">Contest&nbsp;Begins</span>
    <span class="countdown-display__numbers">
        {{days | padLeft}}:{{hours | padLeft }}:{{minutes | padLeft }}:{{seconds | padLeft }}
    </span>
  </div>
</template>

<script>
import Countdown from './../core/countdown';
import { CONTEST_ACTIVE_BEGIN } from '../core/config';

export default {
  name: 'countdown-display',
  filters: {
    padLeft(value, size = 2) {
      let out = String(value);
      while (out.length < (size || 2)) { out = `0${out}`; }
      return out;
    }
  },
  data() {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
      counterReady: false,
    };
  },
  created() {
    this.countdown = new Countdown({
      interval: 'seconds',
      endTime: CONTEST_ACTIVE_BEGIN,
      maxInterval: 'days',
    });

    this.unsubscribeCountdown = this.countdown.subscribe(this.updateDisplay.bind(this));
  },
  mounted() {
    this.countdown.start();
    this.$nextTick(() => {
      this.counterReady = true;
    });
  },

  beforeDestroy() {
    this.unsubscribeCountdown();
    this.countdown.destroy();
  },

  methods: {
    updateDisplay(timeObj) {
      ({
        seconds: this.seconds,
        minutes: this.minutes,
        hours: this.hours,
        days: this.days
      } = timeObj);
    }
  },
};
</script>

<style lang="scss">
  .countdown-display {
    @include eyebrow-text;
    color: $color-base-ninja-yellow-base;
    transition: opacity 200ms linear;
    &--hidden {
      opacity: 0;
    }
    &__numbers {
      white-space: nowrap;
      display: block;
    }

    @include global-media(countdown) {
      &__numbers {
        display: inline;
      }
    }
  }
</style>
